import { AppToOsAwaitedMessage, AppToOSMessageTypes, TelevisitMessage } from '@getvim/vim-os-api';
import { EHR } from '@getvim/vim-os-sdk-api';
import { SdkLogger } from '../sdkLogger';
import { OsCommunicator } from './osCommunicator';

export class TelevisitManager {
  private callbacks = new Set<EHR.AudioListener>();
  private subscriptionId: string | undefined;
  private cancel: (() => void) | undefined;
  constructor(private osCommunicator: OsCommunicator, private logger?: SdkLogger) {}
  public listen = (listener: EHR.AudioListener, encounterId: string) => {
    if (!this.cancel) {
      this.cancel = this.osCommunicator.sendLongLivingMessageToOS<
        AppToOSMessageTypes.SUBSCRIBE_TELEVISIT,
        EHR.AudioListenerPayload
      >(
        {
          type: AppToOSMessageTypes.SUBSCRIBE_TELEVISIT,
          payload: { encounterId },
        },
        this.onMessageFromOS,
      );
    }
    this.callbacks.add(listener);
    return () => {
      this.callbacks.delete(listener);
      if (this.callbacks.size === 0) {
        this.cancel?.();
        if (this.subscriptionId) {
          this.osCommunicator.sendMessageToOS({
            type: AppToOSMessageTypes.UNSUBSCRIBE_TELEVISIT,
            payload: { subscriptionId: this.subscriptionId },
          });
        }
        this.cancel = undefined;
      }
    };
  };

  private onMessageFromOS = (message: AppToOsAwaitedMessage<TelevisitMessage>) => {
    if (message.type === 'subscribed') {
      this.subscriptionId = message.payload.subscriptionId;
      return;
    }
    this.callbacks.forEach((callback) => {
      try {
        callback(message);
      } catch (error: any) {
        this.logger?.error('error with televisit callback', { message }, error);
      }
    });
    if (message.type === 'closed') {
      this.cancel?.();
      this.cancel = undefined;
      this.callbacks.clear();
    }
  };
}
